namespace TabAurous.ECommerce {
    export interface ECommRepairForm {
        TransDate: Serenity.DateEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        POSCustomerId: Serenity.ServiceLookupEditor;
        CustomerName: Serenity.StringEditor;
        Address: Serenity.TextAreaEditor;
        PartyId: Serenity.IntegerEditor;
        Mobile: Serenity.IntegerEditor;
        PanNumber: Serenity.StringEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        BirthDate: Serenity.DateEditor;
        Anniversary: Serenity.DateEditor;
        TaxId: Serenity.StringEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        EmployeeId: Serenity.LookupEditor;
        UserId: Serenity.LookupEditor;
        GSTState: Serenity.StringEditor;
        ImageName: Serenity.ImageUploadEditor;
        ItemDetails: ECommRepairItemsEditor;
        TaxDetails: ECommRepairTaxEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxAmount: AmountEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        RoundOff: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        Receipt: Serenity.DecimalEditor;
        BalanceAmount: Serenity.DecimalEditor;
        Remark: Serenity.TextAreaEditor;
        ShipAddressId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
    }

    export class ECommRepairForm extends Serenity.PrefixedContext {
        static formKey = 'ECommerce.ECommRepair';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ECommRepairForm.init)  {
                ECommRepairForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.ServiceLookupEditor;
                var w4 = s.TextAreaEditor;
                var w5 = s.LookupEditor;
                var w6 = s.DecimalEditor;
                var w7 = s.ImageUploadEditor;
                var w8 = ECommRepairItemsEditor;
                var w9 = ECommRepairTaxEditor;
                var w10 = AmountEditor;

                Q.initFormType(ECommRepairForm, [
                    'TransDate', w0,
                    'TransId', w1,
                    'VoucherNo', w1,
                    'VoucherTypeId', w2,
                    'POSCustomerId', w3,
                    'CustomerName', w1,
                    'Address', w4,
                    'PartyId', w2,
                    'Mobile', w2,
                    'PanNumber', w1,
                    'BillNo', w1,
                    'BillDate', w0,
                    'ChallanNo', w1,
                    'ChallanDate', w0,
                    'BirthDate', w0,
                    'Anniversary', w0,
                    'TaxId', w1,
                    'CurrencyId', w5,
                    'ExchRate', w6,
                    'EmployeeId', w5,
                    'UserId', w5,
                    'GSTState', w1,
                    'ImageName', w7,
                    'ItemDetails', w8,
                    'TaxDetails', w9,
                    'Pieces', w2,
                    'Weight', w6,
                    'NetWeight', w6,
                    'NetAmount', w6,
                    'TaxAmount', w10,
                    'Discount', w6,
                    'AdditionalCharges', w6,
                    'RoundOff', w6,
                    'GrossAmount', w6,
                    'Receipt', w6,
                    'BalanceAmount', w6,
                    'Remark', w4,
                    'ShipAddressId', w2,
                    'FinancialYearId', w2,
                    'CompanyId', w2
                ]);
            }
        }
    }
}
